<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Anchor</h2>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <div :id="settingsFromWeebly.settings.anchorName">
                <div class="only-weebly-editor">
                    <div class="anchor-title-guide">Anchor Element</div>
                    <div class="anchor-label">Copy for linking on the same page:</div>
                    <div class="anchor-name-copy">
                       {{settingsFromWeebly.settings.url+'?data-scroll-to-anchor='+settingsFromWeebly.settings.anchorName}}
                    </div>
                    <div class="anchor-label">Copy for linking from an external page:</div>
                    <div class="anchor-name-copy">
                        {{settingsFromWeebly.settings.url+'?data-anchor-link='+settingsFromWeebly.settings.anchorName}}
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

export default {

    name: 'Anchor',

    data () {

        return {

        }
    },

    components: {

    },

    methods: {
        
    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        }

    },
    
    mounted() {
        console.log('from Anchor', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.preview-box .only-weebly-editor {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Anchor.vue